module.exports = __webpack_public_path__ + "img/gift-history.png";